import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ReturnService } from '../../../return.service';
import { Subscription } from 'rxjs';

export interface ICellRendererParamsForReturnAssetDisposalsListGridAction extends ICellRendererParams {
    viewDetails: (params: ICellRendererParamsForReturnAssetDisposalsListGridAction) => void;
    isHidden: (data: any) => boolean;
}

@Component({
    selector: 'asset-disposals-grid-action-cell',
    template:
        `@if (returnAsset && !isHidden(returnAsset)) {
  <button class="ace-btn btn-primary has-icon grid-action-button" title="View Details" (click)="onViewDetailsClicked()">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})

export class ReturnAssetDisposalsListGridActionCellRendererComponent implements ICellRendererAngularComp, OnDestroy {
    constructor(
        private _returnService: ReturnService) {
    }

    private _params: ICellRendererParamsForReturnAssetDisposalsListGridAction;
    private _returnReadOnlyFlagSub: Subscription;

    returnAsset: Compliance.ReturnAssetModel;
    isReadOnly: boolean = false;
    isHidden: (data: any) => boolean;

    agInit(params: ICellRendererParamsForReturnAssetDisposalsListGridAction): void {
        this._returnReadOnlyFlagSub = this._returnService.isReturnInReadOnlyMode$.subscribe(x => this.isReadOnly = x);
        this.isReadOnly = this._returnService.isReturnInReadOnlyMode;
        this._params = params;
        this.returnAsset = params.data as Compliance.ReturnAssetModel;
        this.isHidden = params.isHidden;

        if (!this.returnAsset) {

        }
    }

    ngOnDestroy(): void {
        this._returnReadOnlyFlagSub.unsubscribe();
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this._params.viewDetails(this._params);
    }
}
